import { render, staticRenderFns } from "./ModalCertificacao.vue?vue&type=template&id=2c414e11&scoped=true"
import script from "./ModalCertificacao.vue?vue&type=script&lang=js"
export * from "./ModalCertificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificacao.vue?vue&type=style&index=0&id=2c414e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c414e11",
  null
  
)

export default component.exports